export default __webpack_public_path__ + "static/media/raaghu.eb038f16.jpg";